import { render, staticRenderFns } from "./TodoMVC.vue?vue&type=template&id=2ee2d506&"
import script from "./TodoMVC.vue?vue&type=script&lang=js&"
export * from "./TodoMVC.vue?vue&type=script&lang=js&"
import style0 from "./TodoMVC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TodoMVC.vue"
export default component.exports